import React from "react";
import "../OtsEventCard/OtsDashboardGrid.scss";
import appSettings from "../../appSettings.js";
import CustomHtmlTooltip from "../../helpers/CustomHtmlTooltip";

interface ACHistoryButtonProps {
  airline: string;
  aircraftRegistration: string;
}

const ACHistoryButton: React.FC<ACHistoryButtonProps> = ({
  airline,
  aircraftRegistration,
}) => {
  const AircraftHistory = "AC History";
  const handleClick = (event: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>) => {
    event.stopPropagation();
    console.log("ac History URL", appSettings.AIRCRAFT_MTX_HISTORY_BASE_URL);
    const aircraftMtxHistoryUrl = `${appSettings.AIRCRAFT_MTX_HISTORY_BASE_URL}?airlines=${airline}&aircraft=N${aircraftRegistration}`;
    window.open(aircraftMtxHistoryUrl, "_blank");
  };

  return (
    <CustomHtmlTooltip
      title={AircraftHistory}
      placement="bottom"
    >
      <div className="edit-box" onClick={handleClick} role="button" tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleClick(e);
        }
      }}>
        <svg
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="Group">
            <path
              id="Vector"
              d="M6.91941 0.827938C6.78017 0.817657 6.6406 0.812508 6.50098 0.8125V0C6.66066 7.78599e-05 6.82029 0.00604024 6.97954 0.017875L6.91941 0.827938ZM8.54766 1.19356C8.28722 1.09305 8.01972 1.01185 7.74735 0.950625L7.92529 0.157625C8.23729 0.2275 8.54225 0.320125 8.84016 0.4355L8.54766 1.19356ZM9.66079 1.77044C9.54463 1.69296 9.42565 1.61978 9.3041 1.55106L9.70466 0.844187C9.9825 1.00154 10.2484 1.17914 10.5001 1.37556L10.0004 2.01663C9.89026 1.93069 9.77697 1.84884 9.66079 1.77125V1.77044ZM11.1509 3.22481C10.9902 2.9965 10.8128 2.78033 10.6204 2.57806L11.2086 2.01744C11.4285 2.24981 11.6308 2.49627 11.8155 2.75681L11.1509 3.22481ZM11.7554 4.32331C11.7021 4.19447 11.6441 4.06764 11.5815 3.94306L12.3071 3.57744C12.4505 3.86272 12.5727 4.15819 12.6727 4.46144L11.9009 4.71575C11.8572 4.5832 11.8087 4.4523 11.7554 4.32331ZM12.186 6.36025C12.1794 6.08103 12.1523 5.80267 12.1048 5.52744L12.9051 5.38931C12.9593 5.70348 12.9907 6.02035 12.9994 6.33994L12.186 6.36025ZM12.0796 7.60988C12.1067 7.47229 12.1286 7.33417 12.1454 7.1955L12.9522 7.29544C12.9131 7.61242 12.8506 7.92608 12.7654 8.23388L11.9821 8.01694C12.0195 7.88315 12.052 7.74746 12.0796 7.60988ZM11.3061 9.54281C11.4556 9.30665 11.5872 9.06073 11.701 8.80506L12.4436 9.13412C12.3136 9.42662 12.1633 9.70775 11.9927 9.9775L11.3061 9.54281ZM10.5229 10.5219C10.622 10.4227 10.7168 10.3204 10.8072 10.2147L11.4231 10.7453C11.3188 10.8663 11.2102 10.9834 11.0973 11.0963L10.5229 10.5219Z"
              fill="#0074C8"
            />
            <path
              id="Vector_2"
              d="M6.5001 0.8125C5.56481 0.812568 4.64398 1.04329 3.81915 1.48423C2.99433 1.92516 2.29098 2.56271 1.77139 3.34039C1.25181 4.11807 0.932029 5.01189 0.84038 5.94267C0.74873 6.87346 0.888038 7.81248 1.24597 8.67657C1.60389 9.54065 2.16939 10.3031 2.89237 10.8965C3.61536 11.4898 4.47351 11.8957 5.39082 12.0782C6.30813 12.2607 7.25629 12.2141 8.15131 11.9427C9.04633 11.6712 9.86059 11.1832 10.522 10.5219L11.0964 11.0963C10.3406 11.8526 9.40986 12.4107 8.38675 12.7213C7.36365 13.0319 6.27972 13.0853 5.23102 12.8769C4.18233 12.6684 3.20123 12.2046 2.37467 11.5263C1.5481 10.8481 0.901594 9.97642 0.492418 8.9886C0.0832427 8.00078 -0.0759644 6.92728 0.0289031 5.86322C0.133771 4.79916 0.499475 3.77739 1.09361 2.88845C1.68775 1.99951 2.49198 1.27084 3.43504 0.767002C4.37811 0.263165 5.43088 -0.000283345 6.5001 2.28685e-07V0.8125Z"
              fill="#0074C8"
            />
            <path
              id="Vector_3"
              d="M6.09473 2.4375C6.20247 2.4375 6.3058 2.4803 6.38199 2.55649C6.45818 2.63267 6.50098 2.73601 6.50098 2.84375V7.07688L9.13998 8.58488C9.23081 8.63967 9.2966 8.72782 9.3233 8.83048C9.35 8.93315 9.33548 9.04218 9.28285 9.13429C9.23022 9.22639 9.14366 9.29425 9.04165 9.32337C8.93965 9.35249 8.8303 9.34056 8.73698 9.29012L5.89323 7.66512C5.83105 7.62961 5.77936 7.57829 5.74341 7.51636C5.70745 7.45444 5.6885 7.38411 5.68848 7.3125V2.84375C5.68848 2.73601 5.73128 2.63267 5.80746 2.55649C5.88365 2.4803 5.98698 2.4375 6.09473 2.4375Z"
              fill="#0074C8"
            />
          </g>
        </svg>
      </div>
    </CustomHtmlTooltip>
  );
};

export default ACHistoryButton;
